import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import constant from '../../constant'
import ChangePassword from '../../old_Components/Settings/ChangePassword';
import SecurityCode from './SecurityCode';
// import UpdatePin from '../../old_Components/Settings/UpdatePin'
import { havesecuritypin } from '../../action/securitypin';
export default class Settings extends Component {
  constructor() {
    super();
    this.state = {

    }
  }
  componentDidMount() {
    document.title = constant.title.Settings
    havesecuritypin().then(res => {
      if (res.status) {
        if (res.result) {
          this.setState({ SECURITY_CODE_ID: res.result.SECURITY_CODE_ID })
        }
        else {
          this.setState({ havehrms: false })
        }
      }
    })
  }
  render() {
    const { havehrms } = this.state
    return (
      <React.Fragment>
        <section className='setingbg padding-top-100px padding-bottom-60px'>
          <div className='container'>
            <div className='row'>
              <div className='col-md-12 text-center'>
                <h1>Your Settings</h1>
              </div>
            </div>
          </div>
        </section>

        <section className='settabsarea'>
          <div className='container'>
            <div className='row'>
              <div className='col-md-12'>
                <ul className='settingstabs'>
                  {/* <li>
                    <Link to={constant.component.Settings.url + '?security-code'} className={(this.props.location.search == '?security-code' || this.props.location.search == '') && 'active'}>Security</Link>
                  </li> */}
                  <li>
                    <Link to={constant.component.Settings.url + '?change-password'} className={this.props.location.search == '?change-password' ? 'active' : ""}>Change Password</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        {/* {
          (this.props.location.search == '?security-code' || this.props.location.search == '') && <SecurityCode
            title={havehrms == false ? 'Set Your Pin' : 'Update Your Pin'}
          />
        } */}
        {
          // this.props.location.search == '?change-password' &&
          < ChangePassword />
        }


      </React.Fragment>
    )
  }
}
